import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=27d55092&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=ts&"
export * from "./Home.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/styles.less?vue&type=style&index=0&id=27d55092&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d55092",
  null
  
)

export default component.exports